
/* React */
import React, { Component } from 'react';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { actions as ruleActions } from '../../redux/ducks/rule'

import { S } from '../../routes/routes';
import Button from '@material-ui/core/Button';
import { SubViewHeaderStep } from '../../lib/components/subHeader';
import { TextInput } from '../../lib/components/textInput';
import { IoteraForm } from '../../lib/components/form';
import { safeDeepGetWithType } from 'iotera-base/json';

function schema() {
  return {
    "definitions": {
      "Category": {
        "title": "Category",
        "type": "number",
        "anyOf": [
          {
            type: 'number',
            enum: [
              11
            ],
            title: 'Incoming Device Data'
          }
        ]
      }
    },
    type: "object",
    required: ["name", "category"],
    properties: {
      name: { type: "string", title: "Nama", maxLength: 30 },
      description: { type: "string", title: "Deskripsi", maxLength: 128 },
      category: {
        "$ref": "#/definitions/Category",
        "title": "Category"
      }
    }
  }
};

const uiSchema = {
  name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Nama"
          placeholder="Nama"
          textTooltip="Masukkan nama untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  description: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="description"
          type="text"
          label="Deskripsi"
          placeholder="Deskripsi"
          textTooltip="Masukkan deskripsi untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class RuleCreateInfo extends Component {
  constructor(props) {
    super(props);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleNext(data) {
    const _this = this;
    const _props = _this.props;
    _props.setCreateInfo(data.formData);
    _props.history.push('.' + S + 'trigger');
  }

  handleBack() {
    const _this = this;
    const _props = _this.props;
    _props.resetCreate();
    _props.history.goBack();
  }

  render() {
    const _this = this;
    const _props = _this.props;
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Rule' subTitle='Rule Info' steps={['Info', 'Trigger', 'Action']} activeStep={0} />
        <div className="io-container mt-12">
          <IoteraForm
            formData={_props.info}
            schema={schema()}
            uiSchema={uiSchema}
            onSubmit={_this.handleNext}
          >
            <div className="button-right">
              <Button variant="outlined" type="button" size="large" 
              style={{ minWidth: '0%' }} onClick={(e) => { _this.handleBack() }} >Kembali</Button>
              <Button variant="contained" size="large" color="primary" type="submit" 
              style={{ marginLeft: 10, minWidth: '0%' }}>Lanjut</Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    info: safeDeepGetWithType(state, ['rule', 'create_info'], {})
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...bindActionCreators(ruleActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleCreateInfo));